import { render, staticRenderFns } from "./settledXMYTab.vue?vue&type=template&id=a711ce5c&scoped=true"
import script from "./settledXMYTab.vue?vue&type=script&lang=js"
export * from "./settledXMYTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a711ce5c",
  null
  
)

export default component.exports